



































import Vue, { PropType } from 'vue';
import CalendarService from '../../../../../../../../frontend/services/CalendarService';
import SearchBannerFormItem from '../SearchBannerFormItem.vue';
import ButtonTabs from '../../../../../../../../frontend/components/ButtonTabs.vue';
import DateRangePlaceholder from '../../../../../../../../frontend/components/DateRangePlaceholder.vue';
import SDCalendarInstance from '../../../../../../../Availability/submodule/Calendar/view/vue/domain/SDCalendarInstance';
import { DateValue } from '../../../../../../../../frontend/store/modules/factory/searchBanner';
import type { DrawerConfig } from '../types';

type CalendarParams = {
  desktop: boolean;
  selected?: string;
  selection_from?: string;
  selection_till?: string;
  date_shortcut?: string;
  limit?: number;
};

export default Vue.extend({
  name: 'SearchBannerDateCalendar',
  components: {
    SDCalendar: () =>
      import(
        '../../../../../../../Availability/submodule/Calendar/view/vue/components/SDCalendar.vue'
      ),
    SearchBannerFormItem,
    ButtonTabs,
    DateRangePlaceholder,
  },
  props: {
    storeNamespace: {
      type: String,
      required: true,
    },
    isDesktop: {
      type: Boolean,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    drawerConfig: {
      type: Object as PropType<DrawerConfig>,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    flow: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      calendar: null as SDCalendarInstance | null,
      params: {
        desktop: true,
        limit: 3,
      } as CalendarParams,
    };
  },
  computed: {
    displayValue(): string | undefined {
      if (this.isDesktop) {
        return this.$store.getters[`${this.storeNamespace}/dateDisplayValueDesktop`];
      }
      return this.$store.getters[`${this.storeNamespace}/dateDisplayValueMobile`];
    },
    amountData(): number {
      return this.$store.getters[`${this.storeNamespace}/amountData`] ?? 1;
    },
    dateData(): DateValue {
      return this.$store.getters[`${this.storeNamespace}/dateData`] ?? {};
    },
    citySlug(): string {
      return this.$store.getters[`${this.storeNamespace}/citySlug`] ?? '';
    },
    showDateRange(): boolean {
      return this.calendar && !!this.calendar.boxCheckinCheckout;
    },
    isActive: {
      get(): boolean {
        return this.active;
      },
      set(value: boolean) {
        this.$emit('update:active', value);
      },
    },
  },
  methods: {
    async fetchCalendar(params: unknown, setRefetching = true) {
      if (!this.citySlug) {
        return;
      }

      if (setRefetching) {
        this.$store.commit(`${this.storeNamespace}/setRefetching`, true);
      }

      this.calendar = await CalendarService.getSearchBarCalendar(
        this.flow,
        Number(this.amountData),
        this.citySlug,
        params
      );

      if (setRefetching) {
        this.$store.commit(`${this.storeNamespace}/setRefetching`, false);
      }
    },
    async handleNoPreferenceClick() {
      if (!this.calendar?.unselect?.params) {
        this.$emit('date-selected');
        this.isActive = false;
        return;
      }

      await this.fetchCalendar(this.calendar.unselect.params);
      await this.$store.dispatch(`${this.storeNamespace}/clearDate`);

      this.$emit('date-selected');
      this.isActive = false;
    },
    async handleCalendarUpdate(params: any) {
      this.fetchCalendar(params);
      const datePayload: DateValue = {};
      const hasDateSelection = params.selected;
      const hasDateRange = this.showDateRange && params.selection_from && params.selection_till;

      if (hasDateSelection) {
        datePayload.date = params.selected;
      }

      if (hasDateRange) {
        datePayload.fromDate = params.selection_from;
        datePayload.toDate = params.selection_till;
      }

      if (hasDateSelection || hasDateRange) {
        await this.$store.dispatch(`${this.storeNamespace}/updateDate`, datePayload);
        this.$emit('date-selected');
        this.isActive = false;
      }
    },
    async handleShortcutClick(params: any) {
      await this.fetchCalendar(params);

      const datePayload: DateValue = {};
      if (params.date_shortcut) {
        datePayload.dateShortcut = params.date_shortcut;
      }

      await this.$store.dispatch(`${this.storeNamespace}/updateDate`, datePayload);
      this.$emit('date-selected', datePayload);
      this.isActive = false;
    },
    async handleCalendarLoadMore(params: any) {
      await this.fetchCalendar(Object.assign({}, this.params, params));
    },
  },
  mounted() {
    this.fetchCalendar(this.params, false);
  },
});
